import React from 'react'
import Box from '../components/Box'

export default function Section4() {
    return (
        <div className="section">
            <h2>Section IV: Assignments</h2>
            <Box sectionData={'start'} title={'Create Assignment'} body={`Note:  
            • Extra credit assignments can be created by entering a possible points value of zero. 
            1. Tap the “Manage” button and select “Assignments” from the menu. 
            2. Tap the “+” button to add an assignment.  
            3. Enter at least the assignment name and possible points. 
            4. If the class is categorized tap the category field and select a correct category from the list. 
            5. Tap “Save” to save the entered information and return to the assignment manager screen. Tap 
            “Save & Add” to save the entered information and immediately add another assignment.`} />




            <Box title={'Edit Assignment '} body={`1. Tap the “Manage” button and select “Assignments” from the menu. 
            2. Tap the assignment to be edited. 
            3. Make the desired changes and tap “Save”. 
            4. Tap “Done”.`} />




            <Box title={'Delete Assignment'} body={`Note:  
            • Deleting  an  assignment  will  delete  all  entered  scores  for  the  assignment.  This  cannot  be 
            undone. 
            1. Tap the “Manage” button and select “Assignments” from the menu. 
            2. Tap the “Edit” button.  
            3. Tap the “-“ button on the assignment to be deleted. 
            4. Confirm by tapping the “Delete” button. 
            5. Confirm again by selecting ‘Delete Assignment’.`} />




            <Box title={'Quick Add Assignment'} body={`1. Select a class as described above. 
            2. Tap the “Actions” button on the bottom toolbar. 
            3. Select “Create Assignment” 
            4. Follow steps (3) – (5) in the “Create Assignments” section above.`} />



            <Box sectionData={'end'} title={'Copy Assignment '} body={`Note: 
            • If  the  class  is  categorized  the  assignment  will  be  placed  into  the  matching  category.  If  no 
            matching category exists it will be placed in a new category called “Uncategorized”. 
            1. Select the destination class as described previously.  
            2. Tap the “Manage” button and select “Assignments” from the menu. 
            3. Tap the “Copy” button on the top toolbar.  
            4. Select the source class from the list.  
            5. Select the assignments to be copied and tap “Done”`} />
        </div>
    )
}